import {
  AppTimeSeriesRaw,
  AppTimeSeriesV2Raw,
} from '../dto/top-apps/cube/raw/app-time-series.dto';
import { AppTimeSeriesResult } from '../dto/top-apps/cube/mapped/app-time-series-result.dto';
import {
  IWorkingDaysAnalyticsActivityV2Enum,
  IWorkingDaysAnalyticsActivityEnum,
} from '../enum/working-days-analytics-activity.enum';

export const mapAppTimeSeriesCube = (
  model: AppTimeSeriesRaw
): AppTimeSeriesResult => {
  return {
    date: model[IWorkingDaysAnalyticsActivityEnum.LocalStartTime],
    duration:
      Number(model[IWorkingDaysAnalyticsActivityEnum.TotalDuration]) || 0,
    count: Number(model[IWorkingDaysAnalyticsActivityEnum.count]) || 0,
    callDuration: 0,
    callCount: 0,
  };
};

export const mapAppTimeSeriesCubeV2 = (
  model: AppTimeSeriesV2Raw
): AppTimeSeriesResult => {
  return {
    date: model[IWorkingDaysAnalyticsActivityV2Enum.LocalStartTime],
    duration:
      Number(model[IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]) || 0,
    count: Number(model[IWorkingDaysAnalyticsActivityV2Enum.count]) || 0,
    callDuration:
      Number(model[IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]) || 0,
    callCount:
      Number(model[IWorkingDaysAnalyticsActivityV2Enum.CallCount]) || 0,
  };
};
